import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import colorSharp from "../assets/img/color-sharp.png"
import { SkillItem } from './SkillItem'

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx wow zoomIn">
              <h2>Skills</h2> <hr className="divider" />
              <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                <SkillItem src={'react'} skill={'React.js'} />
                <SkillItem src={'mui'} skill={'Material UI'} />
                <SkillItem src={'redux'} skill={'Redux'} />
                <SkillItem src={'html'} skill={'HTML'} />
                <SkillItem src={'css'} skill={'CSS'} />
                <SkillItem src={'javascript'} skill={'Javascript'} />
              </Carousel>
              <p>Frontend and UI/UX</p>

              <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                <SkillItem src={'node-js'} skill={'Node.js'} />
                <SkillItem src={'flask'} skill={'Flask'} white={true} />
                <SkillItem src={'php'} skill={'Apache PHP'} />
                <SkillItem src={'mongodb'} skill={'MongoDB'} />
                <SkillItem src={'postgre'} skill={'PostgreSQL'} />
              </Carousel>
              <p>Backend and Databases</p>

              <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                <SkillItem src={'git'} skill={'GIT & GITHUB'} />
                <SkillItem src={'aws-api'} skill={'AWS API GATEWAY'} />
                <SkillItem src={'aws-ec2'} skill={'AWS EC2'} />
                <SkillItem src={'aws-lambda'} skill={'AWS Lambda'} />
                <SkillItem src={'aws-s3'} skill={'AWS S3'} />
                <SkillItem src={'vercel'} skill={'Vercel'} />
                <SkillItem src={'firebase'} skill={'Firebase'} />
                <SkillItem src={'vscode'} skill={'VS Code'} />
              </Carousel>
              <p>Version Controls and Deployments</p>

              <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                <SkillItem src={'c++'} skill={'C++'} />
                <SkillItem src={'opencv'} skill={'OpenCV'} />
                <SkillItem src={'photoshop'} skill={'Photoshop'} />
              </Carousel>
              <p>Miscellaneous</p>

            </div>
          </div>
        </div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="left" />
    </section>
  )
}
